// import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
// import { ApiHelperFunction } from '../Helper/Helper';

import { createSlice } from "@reduxjs/toolkit";
import { apiSlice } from "./apiSlice";



export const ProductSlice = createSlice({
    name: 'Product',
    initialState: { productInfo: {}, productCurrentStep: "STEP1" },
    reducers: {

        setProductInfo(state, action) {
            state.productInfo = { ...state.productInfo, ...action.payload }
        },
        setProductInfoFromApi(state, action) {
            state.productInfo = action.payload
        },
        setProductCurrentStep(state, action) {
            state.productCurrentStep = action.payload
        },
        setCleanProductinfo(state, action) {

            state.productInfo = {}
        }
    },
})

export default ProductSlice.reducer;
export const { setProductInfo, setProductCurrentStep, setProductInfoFromApi, setCleanProductinfo } = ProductSlice.actions;
export const getProductInfos = (state) => state?.Product?.productInfo;
export const getProductStep = (state) => state?.Product?.productCurrentStep;


export const productApi = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        createProduct: builder.mutation({
            query: (data) => ({
                url: "/product/basicinformation",
                method: "POST",
                body: data,
                credentials: "include",
            }),

            invalidatesTags: ['Products', 'Product'],


            async onQueryStarted(data, { dispatch, queryFulfilled, getState }) {
                try {
                    const result = await queryFulfilled
                    const getProducInfo = await getState()?.Product?.productInfo



                    const pdId = getProducInfo?.id || getProducInfo?.productId || result?.data?.response;

                    if (result?.data?.response) {


                        dispatch(setProductInfoFromApi({ ...data, productId: pdId, id: pdId }))
                    } else {
                        dispatch(setProductInfo({ ...data, productId: pdId, id: pdId }))
                    }



                } catch { }
            },


        }),
        createProductStepTwo: builder.mutation({
            query: (data) => ({
                url: "/product/productveriant",
                method: "POST",
                body: data,
                credentials: "include",
            }),
            invalidatesTags: ['Products', 'Product'],

            async onQueryStarted(data, { dispatch, queryFulfilled, getState }) {
                try {
                    const result = await queryFulfilled


                    // dispatch(setProductInfo({ ...data }))



                } catch { }
            },


        }),
        createProductStepThree: builder.mutation({
            query: (data) => ({
                url: 'product/relatedproduct',
                method: "POST",
                body: data,
                credentials: "include",
            }),
            invalidatesTags: ['Products', 'Product'],


        }),
        createProductStepColorCatgoryVarient: builder.mutation({
            query: (data) => ({
                url: 'product/similarColour',
                method: "POST",
                body: data,
                credentials: "include",
            }),
            invalidatesTags: ['Products', 'Product'],


        }),

        createProductStepFour: builder.mutation({
            query: (data) => ({
                url: 'product/boughtTogether',
                method: "POST",
                body: data,
                credentials: "include",
            }),
            invalidatesTags: ['Products', 'Product'],


            async onQueryStarted(data, { dispatch, queryFulfilled, getState }) {
                try {
                    const result = await queryFulfilled

                    dispatch(setProductInfoFromApi({}))


                    // dispatch(setProductInfo({ ...data }))



                } catch { }
            },

        }),

        productList: builder.mutation({
            query: (data) => ({
                url: "/product?" + data,
                method: "GET",
                credentials: "include",
            }),
            providesTags: ['Products', 'Product'],

        }),
        getProductsList: builder.query({


            query: (queryParams) => {
                const searchparams = new URLSearchParams();

                queryParams.forEach((element) => {
                    searchparams.append(element.name, element.value);
                });

                return {
                    url: `product/`,
                    method: 'GET',
                    params: searchparams,
                };
            },

            // query: (data) => ({
            //     url: "/product",
            //     method: "GET",
            //     credentials: "include",
            //     params
            // }),
            providesTags: ['ProductsList'],

        }),
        deleteProduct: builder.mutation({
            query: (productId) => ({
                url: "/product",
                method: "DELETE",
                body: productId,
                credentials: "include",
            }),
            invalidatesTags: ['ProductsList']

        }),
        relatedProductByID: builder.query({
            query: (productId) => ({
                url: "/product/relatedProduct/" + productId,
                method: "GET",
                credentials: "include",
            })

        }),
        productShow: builder.query({
            query: (productId) => ({
                url: `/product/${productId}`,
                method: "GET",
                credentials: "include",
            }),
            providesTags: ['Product'],

            async onQueryStarted(data, { dispatch, queryFulfilled, getState }) {
                try {
                    const result = await queryFulfilled;
                    const getProducInfo = await getState()?.Product?.productInfo;
                    // const pdId = getProducInfo?.id || getProducInfo?.productId;

                    // const stepTwoRes = result?.data?.response;

                    // const productSizeColourCombinationsData = stepTwoRes?.ProductSizeColourCombinations?.map(it => ({ id: it?.id, MRP: it?.MRP, quantity: it?.quantity, sellingPrice: it?.sellingPrice, skuId: it?.skuId, productColourId: { value: it?.ProductColour?.id, label: it?.ProductColour?.name }, sizeId: { value: it?.Size?.id, label: it?.Size?.name } }));
                    // const productSizeImgColourData = stepTwoRes?.ProductImageColourCombinations?.map(it => ({ ...it, productColourId: { value: it?.productColourId, label: it?.ProductColour?.name } }));


                    // dispatch(setProductInfo({
                    //     ...result?.data?.response,
                    //     "productId": pdId
                    //     ,
                    //     "sizes": stepTwoRes?.ProductSizeCombinations?.map(it => ({
                    //         value: it?.sizeId, label: it?.Size?.name
                    //     })),
                    //     "colours": stepTwoRes?.ProductColourCombinations?.map(it => ({
                    //         value: it?.productColourId, label: it?.ProductColour?.name
                    //     })),
                    //     "productImageColourData": productSizeImgColourData,
                    //     "productSizeColourData": productSizeColourCombinationsData,
                    //     'sizesShowData': stepTwoRes?.ProductSizeCombinations?.map(it => ({
                    //         value: it?.sizeId, label: it?.Size?.name
                    //     })),
                    //     "colorsShowData": stepTwoRes?.ProductColourCombinations?.map(it => ({
                    //         value: it?.productColourId, label: it?.ProductColour?.name
                    //     })),
                    //     // }

                    // }))
                    // dispatch(setSelectedCategory(result?.data?.response?.ProductCategoryCombinations?.map(it => it?.categoryId)))
                } catch { }
            },



        }),

        ActiveProductlist: builder.mutation({
            query: (data) => ({
                url: "product/active/product?" + data,
                method: "GET",
                credentials: "include",
            }),
            providesTags: ['Products', 'Product'],
        }),
        getActiveProductslist: builder.query({
            query: () => ({
                url: "product/active/product1?page=1&limit=100",
                method: "GET",
                credentials: "include",
            }),
            providesTags: ['Products', 'Product'],
        }),

        specificationProduct: builder.mutation({
            query: (data) => ({
                url: "/productSpecification",
                method: "POST",
                body: data,
                credentials: "include",
            }),

        }),
        uniqueColorProductInfo: builder.query({
            query: (uniqueColourCode) => ({
                url: `/product/similar/uniqueColourCode?inputValue=${uniqueColourCode}`,
                method: "GET",
                credentials: "include",
            }),
            transformResponse: (res) => res?.response

        }),


    }),
});

export const {
    useCreateProductMutation,
    useCreateProductStepTwoMutation,
    useProductListMutation,
    useGetProductsListQuery,
    useCreateProductStepThreeMutation,
    useCreateProductStepFourMutation,
    useActiveProductlistMutation,
    useProductShowQuery,
    useDeleteProductMutation,
    useGetActiveProductslistQuery,
    useSpecificationProductMutation,
    useCreateProductStepColorCatgoryVarientMutation,
    useUniqueColorProductInfoQuery,
    useRelatedProductByIDQuery
} = productApi;


